import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LaunchPublic() {
  const { id } = useParams();
  const [l, setL] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { fetch(`${API}/api/public/launches/${id}`).then((r) => (r.ok ? r.json() : Promise.reject())).then(setL).catch(() => setErr(true)); }, [id]);
  if (err) return <div className="p-10 text-center text-sm text-muted-foreground" data-testid="launch-public-missing">This offer is no longer available.</div>;
  if (!l) return <div className="p-10 text-center text-sm text-muted-foreground">Loading...</div>;
  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#FBF9F4] p-5" data-testid="launch-public-page">
      <div className="text-xs uppercase tracking-[0.2em] text-[#D96B43]">New from {l.business || "Nex Fresh"}</div>
      <h1 className="mt-1 font-display text-3xl font-bold text-[#0F382C]" data-testid="launch-public-title">{l.title}</h1>
      <img src={`${API}/api/public/launches/${l.id}/photo`} alt={l.title} className="mt-4 w-full rounded-3xl object-cover shadow-lg" data-testid="launch-public-photo" />
      <p className="mt-4 whitespace-pre-line text-base text-[#1f2937]">{l.message}</p>
      <p className="mt-6 text-sm text-muted-foreground">Reply on WhatsApp to order, or tell your delivery partner tomorrow morning.</p>
    </div>
  );
}
